import { createI18n } from 'vue-i18n'
import zhTW from './locales/zh-TW'
import zhCN from './locales/zh-CN'
import enUS from './locales/en-US'
import viVN from './locales/vi-VN'
import thTH from './locales/th-TH'

/** 所有受支持的语言代码 */
export type SupportedLocale = 'zh-TW' | 'zh-CN' | 'en-US' | 'vi-VN' | 'th-TH'

/** 语言元数据 */
export interface LocaleMeta {
  code: SupportedLocale
  name: string
  nativeName: string
  /** false = 预留，不在 UI 列表显示 */
  enabled: boolean
}

export const SUPPORTED_LOCALES: LocaleMeta[] = [
  { code: 'zh-TW', name: 'Traditional Chinese', nativeName: '繁體中文',    enabled: true  },
  { code: 'zh-CN', name: 'Simplified Chinese',  nativeName: '简体中文',    enabled: true  },
  { code: 'en-US', name: 'English',             nativeName: 'English',     enabled: true  },
  { code: 'vi-VN', name: 'Vietnamese',          nativeName: 'Tiếng Việt', enabled: false }, // 预留
  { code: 'th-TH', name: 'Thai',                nativeName: 'ภาษาไทย',    enabled: false }, // 预留
]

export const DEFAULT_LOCALE: SupportedLocale = 'zh-TW'

/** zh-TW 漏 key 优先回退 zh-CN，再回退 en-US */
export const FALLBACK_LOCALE: SupportedLocale[] = ['zh-CN', 'en-US']

export type MessageSchema = typeof zhTW

export const i18n = createI18n<[MessageSchema], SupportedLocale>({
  legacy: false,          // Composition API 模式
  globalInjection: true,
  locale: DEFAULT_LOCALE,
  fallbackLocale: { default: FALLBACK_LOCALE },
  messages: {
    'zh-TW': zhTW,
    'zh-CN': zhCN,
    'en-US': enUS,
    'vi-VN': viVN,
    'th-TH': thTH,
  },
  missingWarn: import.meta.env.DEV,
  fallbackWarn: false,
})

export default i18n
